<template>
  <div class="input-group filter-input-container">
    <div class="input-group-prepend">
      <span class="input-group-text input-icon">
        <i class="fas fa-search"></i>
      </span>
    </div>
    <input
      ref="filterInput"
      type="text"
      class="form-control filter-input"
      placeholder="Buscar Dashboard/Informe"
      :value="value"
      @input="updateInput"
    />
  </div>
</template>

<script>
export default {
  name: 'DashboardReportFilter',
  props: {
    value: { type: String, default: null },
  },
  data() {
    return {
      filterText: null,
    }
  },
  methods: {
    updateInput() {
      this.$emit('input', this.$refs.filterInput.value)
    },
  },
}
</script>

<style scoped>
.filter-input-container {
  border: #f4f6f3 solid 8px;

}

.filter-input {
  border: #E2E2E2 solid 1px;
}

.input-icon{
    background-color:#FF7058;
    color:white;
}
</style>
